// extracted by mini-css-extract-plugin
module.exports = {"modal_s":"Tags_modal_s__1aBQA"};